import { DomesticShipment } from '../shipment';

import { MockShipment } from './shipment.mock';

export class MockDomesticShipment extends DomesticShipment {
   constructor() {
      super( new MockShipment() );
   }
}
